import GlobalStyles from './theme/globalStyles';
import RtlLayout from './components/util/RtlLayout';
import ScrollToTop from './components/util/ScrollToTop';
import { ProgressBarStyle } from './components/util/LoadingScreen';
import { reactPlugin, getOrSetUpAppInsights } from 'appInsights';
import { AppInsightsContext, withAITracking } from '@microsoft/applicationinsights-react-js';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { enGB } from 'date-fns/locale/en-GB';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import BuildVersionGuard from 'guards/BuildVersionGuard';
import CustomSnowfall from 'components/CustomSnowfall';
import UnsavedChangesPrompt from 'components/form/UnsavedChangesPrompt';
import { MaintenancePage } from 'pages/maintenance/MaintenancePage';
import releaseConfig from 'releaseConfig';
import { useRemoteConfig } from 'utils/firebase/useRemoteConfig';
import {
  RemoteConfigKeyConfiguration,
  UnderMaintenanceConfigDev
} from 'utils/firebase/remoteConfigKey';
import AdminApp from 'AdminApp';
import { Route, Routes } from 'react-router';
import NpsCalculatorApp from 'NpsCalculator/NpsCalculatorApp';
import { EventType, PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from 'authConfig';

getOrSetUpAppInsights();

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.addEventCallback((event: any) => {
  if (
    (event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
      event.eventType === EventType.LOGIN_SUCCESS) &&
    event.payload.account
  ) {
    const account = event.payload.account;
    msalInstance.setActiveAccount(account);
  }
});

const App = () => {
  const { getRemoteConfigValue } = useRemoteConfig();

  const keyConfig: RemoteConfigKeyConfiguration = releaseConfig.underMaintenanceKey.startsWith('#{')
    ? UnderMaintenanceConfigDev
    : { key: releaseConfig.underMaintenanceKey, type: 'boolean' };
  const underMaintenance = getRemoteConfigValue(keyConfig);

  return underMaintenance ? (
    <MaintenancePage />
  ) : (
    <div style={{ position: 'relative' }}>
      <CustomSnowfall />
      <AppInsightsContext.Provider value={reactPlugin}>
        <LocalizationProvider
          dateAdapter={AdapterDateFns}
          localeText={{ start: 'From', end: 'To' }}
          adapterLocale={enGB}
        >
          <RtlLayout>
            <BuildVersionGuard>
              <GlobalStyles />
              <ProgressBarStyle />
              <ScrollToTop />
              <Routes>
                <Route path="/nps-calculator" element={<NpsCalculatorApp />} />
                <Route path="*" element={<AdminApp msalInstance={msalInstance} />} />
              </Routes>
            </BuildVersionGuard>
          </RtlLayout>
        </LocalizationProvider>
      </AppInsightsContext.Provider>
      <UnsavedChangesPrompt />
    </div>
  );
};

export default withAITracking(reactPlugin, App);
